import { cn } from '@polyseme/utils/cn/cn-utils';

import { Skeleton } from '../../ui';

type ChartAreaAxesSkeletonProps = {
  /** Sized to match the live chart so the placeholder doesn't cause a layout jump. */
  className?: string;
};

export const ChartAreaAxesSkeleton = ({
  className = 'h-[200px] w-full md:h-[300px] lg:h-[440px]',
}: ChartAreaAxesSkeletonProps) => (
  <Skeleton className={cn('rounded-xl bg-gray-100', className)} />
);
